import { render, staticRenderFns } from "./writing_send.vue?vue&type=template&id=26712bea&scoped=true&"
import script from "./writing_send.vue?vue&type=script&lang=js&"
export * from "./writing_send.vue?vue&type=script&lang=js&"
import style0 from "./writing_send.vue?vue&type=style&index=0&id=26712bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26712bea",
  null
  
)

export default component.exports